import {
  FETCH_LOGIN_BEGIN,
  FETCH_LOGIN_SUCCESS,
  FETCH_LOGIN_FAILURE,
  FETCH_USERS_BEGIN,
  FETCH_USERS_SUCCESS,
  FETCH_USERS_FAILURE,
  FETCH_USER_BEGIN,
  FETCH_USER_SUCCESS,
  FETCH_USER_FAILURE,
  DELETE_USER_BEGIN,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAILURE,
  FETCH_CONFIRM_RESET_PASSWORD_BEGIN,
  FETCH_CONFIRM_RESET_PASSWORD_SUCCESS,
  FETCH_CONFIRM_RESET_PASSWORD_FAILURE,
  LOG_USER_OUT,
} from "../actions/User";

const initialState = {
  loggedInUser: JSON.parse(localStorage.getItem("user")) || undefined,
  user: {},
  users: [],
  loading: false,
  error: null,
};

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_CONFIRM_RESET_PASSWORD_BEGIN:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_CONFIRM_RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case FETCH_CONFIRM_RESET_PASSWORD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case FETCH_LOGIN_BEGIN:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        loggedInUser: action.payload,
      };

    case FETCH_LOGIN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        loggedInUser: {},
      };
    case FETCH_USERS_BEGIN:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        users: action.payload,
      };

    case FETCH_USERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        users: [],
      };

    case FETCH_USER_BEGIN:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        user: action.payload,
      };

    case FETCH_USER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        user: {},
      };

    case DELETE_USER_BEGIN:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case DELETE_USER_SUCCESS:
      return {
        ...state,
        loading: false,
      };

    case DELETE_USER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case LOG_USER_OUT:
      return {
        ...state,
        loggedInUser: {},
      };

    default:
      return state;
  }
}
